import React from 'react';
import AppSwitch, { AppSwitchSize } from '../../../components/atoms/AppSwitch/AppSwitch';

interface SwitchCriteriaFormProps {
  onChange: (e: boolean) => void;
  checkPrefix?: string;
  checkSuffix?: string;
  checked: boolean;
  title?: string;
  size?: AppSwitchSize;
}

export const SwitchCriteriaForm = ({
  checkPrefix,
  checked,
  checkSuffix,
  onChange,
  title,
  size = 'default',
}: SwitchCriteriaFormProps) => {
  const [dataForm, setData] = React.useState(checked);
  const isCompact = size === 'compact';
  const hasTitle = title !== undefined;
  const labelClassName = isCompact
    ? 'text-sm leading-none font-normal text-[#475569]'
    : '';

  return (
    <div className={hasTitle ? 'flex flex-col gap-2' : 'flex w-full items-center h-11'}>
      {hasTitle && <p className="text-sm leading-none font-medium text-[#475569] mt-1">{title}</p>}
      <div className={hasTitle ? 'flex items-center gap-2 h-11' : 'flex items-center'}>
        {checkPrefix !== undefined && <p className={isCompact ? labelClassName : 'mr-2'}>{checkPrefix}</p>}
        <AppSwitch
          size={size}
          checked={dataForm}
          onChange={(value) => {
            setData(value);
            onChange(value);
          }}
        />
        {checkSuffix !== undefined && <p className={isCompact ? labelClassName : 'ml-2'}>{checkSuffix}</p>}
      </div>
    </div>
  );
};
